
export default function LoadingPulse({ height = "h-3", width = "w-16" }: { height?: string; width?: string }) {

  return (
    <div className="flex justify-center items-center flex-1 animate-pulse">
      <div className={`${height} ${width} rounded-full p-1 text-sm font-semibold bg-gray-200`}></div>
    </div>
  )
}